import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@client/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center font-semibold transition-all active:opacity-70 disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        primary: 'text-primary',
        destructive: 'text-destructive',
        secondary: 'text-foreground',
        filled: 'bg-primary text-primary-foreground rounded-[10px] px-4 py-2',
        gray: 'bg-secondary text-foreground rounded-[10px] px-4 py-2',
      },
      size: {
        default: 'text-[17px] leading-[22px]',
        sm: 'text-[15px] leading-[20px]',
        lg: 'text-[20px] leading-[25px]',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
);

interface IOSButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function IOSButton({ className, variant, size, ...props }: IOSButtonProps) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
